export default "__VITE_ASSET__DG2M7N0n__"